// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__lhoqs","detailsBorder":"styles_detailsBorder__1wYxg"};